import type { DataFetchParams } from '@/components/DataTable';
import { USER_SECURITY_POSTURE_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/user-security-posture';

const HIDDEN_COLUMN_FILTER_FIELDS = new Set<string>([
  USER_SECURITY_POSTURE_FILTERABLE_FIELDS.ENDPOINTS,
  USER_SECURITY_POSTURE_FILTERABLE_FIELDS.AGENT_VERSION,
]);
const HIDDEN_COLUMN_SORT_FIELDS = new Set<string>([
  'endpointCount',
  'leastAgentVersion',
]);

/** Drop Endpoints / Agent version filter+sort when those columns are hidden. */
export function sanitizeUspParams(
  params: DataFetchParams,
  endpointsColumnEnabled: boolean
): DataFetchParams {
  if (endpointsColumnEnabled) return params;
  const filters = params.filters.filter(
    f => !HIDDEN_COLUMN_FILTER_FIELDS.has(f.field)
  );
  const sort =
    params.sort?.field && HIDDEN_COLUMN_SORT_FIELDS.has(params.sort.field)
      ? undefined
      : params.sort;
  return { ...params, filters, sort };
}
